/* SaGó — D6 · chevrones para pasar de foto sin bajar a la galería.
 *
 * La mitad del trabajo la hace el CSS: Dawn ya renderiza un `.slider-buttons`
 * con prev/next dentro del <slider-component> de la galería, y en móvil
 * funcionan solos porque ahí la lista de medios SÍ es un carrusel. Lo único que
 * les pasaba es que estaban debajo de la foto en vez de encima.
 *
 * En escritorio no vale lo mismo, y conviene saber por qué antes de tocar:
 * con `gallery_layout: thumbnail_slider`, Dawn esconde esos botones
 * (section-main-product.css, `.product__media-container .slider-buttons`) y la
 * lista deja de ser un carrusel — sólo se pinta el medio activo y se navega por
 * las miniaturas. Un botón de carrusel ahí no movería nada.
 *
 * Así que en escritorio se reutiliza la API que Dawn ya expone en el elemento
 * <media-gallery>: setActiveMedia(mediaId, prepend). No se bifurca ningún
 * fichero de Dawn — ni el snippet ni media-gallery.js — para que la próxima
 * actualización no tenga que fusionar nada. Ver evidencia/bloque-C-D.md.
 *
 * Medido en la preview: la galería de producto expone setActiveMedia y
 * data-desktop-layout="thumbnail_slider" con 4 medios.
 */
(() => {
  const ESCRITORIO = window.matchMedia('(min-width: 750px)');

  /* Sólo los <li> de la galería, y NO cualquier [data-media-id].
     product-thumbnail.liquid pone data-media-id="{{ media.id }}" —el id pelado,
     sin el prefijo de sección— también en el <button> de zoom que va DENTRO de
     cada <li>, y en <product-model>/<deferred-media> para vídeo y 3D. Con un
     selector abierto, una galería de 4 fotos devolvía 8 elementos intercalados:
     el «siguiente» era el botón de la misma foto, no la foto siguiente. Y como
     en escritorio Dawn esconde todo .product__media-item:not(.is-active), pasar
     el is-active a un botón dejaba la galería EN BLANCO. */
  const mediosDe = (galeria) => [
    ...galeria.querySelectorAll('[id^="GalleryViewer"] .product__media-item[data-media-id]'),
  ];

  function mover(galeria, paso) {
    const medios = mediosDe(galeria);
    if (medios.length < 2) return;
    const actual = medios.findIndex((m) => m.classList.contains('is-active'));
    const destino = medios[((actual < 0 ? 0 : actual) + paso + medios.length) % medios.length];
    if (destino) galeria.setActiveMedia(destino.dataset.mediaId, false);
  }

  /* En captura, para llegar antes que el manejador del <slider-component> de
     Dawn. En móvil no se hace nada: ahí ese manejador es el que vale, y
     duplicarlo saltaría dos fotos de una. */
  document.addEventListener(
    'click',
    (ev) => {
      if (!ESCRITORIO.matches) return;
      const boton = ev.target.closest('.product__media-wrapper .slider-button');
      if (!boton) return;
      const galeria = boton.closest('media-gallery');
      if (!galeria || typeof galeria.setActiveMedia !== 'function') return;
      ev.preventDefault();
      ev.stopPropagation();
      mover(galeria, boton.name === 'previous' ? -1 : 1);
    },
    true
  );

  /* Del 24/09 al 15/10 aquí se medía el hueco blanco que dejaba la foto a cada
     lado en escritorio (`--sago-flechas-izq/-der`) para que las flechas no
     quedaran en el blanco: la foto se estrechaba a su proporción, 2:3. Desde
     Producto 2 la foto es 4:5 y llena su columna en todos los anchos
     (sago-overrides.css), así que la capa de las flechas ya coincide con ella
     y no hay nada que medir. */
})();
